module.exports = __webpack_public_path__ + "materialdesignicons-webfont.cc3cf0bd5af9550e4d18.woff2";


//////////////////
// WEBPACK FOOTER
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.woff2?v=1.8.36
// module id = ../../../../../src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.woff2?v=1.8.36
// module chunks = styles